import { IconButton, Tooltip } from '@mui/material';
import { useThemeStore } from '@store/useThemeStore';
import { Moon, Sun } from 'lucide-react';

export const ThemeToggleButton = () => {
  const mode = useThemeStore(state => state.mode);
  const toggleMode = useThemeStore(state => state.toggleMode);

  return (
    <Tooltip title={mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}>
      <IconButton aria-label="Toggle color mode" onClick={toggleMode}>
        {mode === 'light' ? <Moon size={18} /> : <Sun size={18} />}
      </IconButton>
    </Tooltip>
  );
};
